const paginationProps = {
  current_page: 1,
  next_page: null,
  previous_page: null,
  total_entries: 0,
};
const initialState = {
  stepsStatus: {},
  isLoading: false,
  isCreatingForm: false,
  isAddingReviewee: false,
  isAddingMultipleReviewees: false,
  isRemovingAllReviewees: false,
  isRemovingSingleReviewee: false,
  isFetchingReviewCycleDetails: false,
  competencyError: [],
  newlyCreatedReviewCycle: {},
  reviewForms: [],
  reviewFormTemplates: {
    system_templates: [],
    user_templates: [],
  },
  reviewFormQuestions: [],
  questionLibrary: {
    system_question_templates: [],
    user_question_templates: [],
  },
  employees: [],
  employeesWithPagination: {
    data: [],
    pagination: {
      limit: 10,
      ...paginationProps,
    },
  },
  reviewees: null,
  revieweesWithPagination: {
    reviewees: [],
    per_page: 10,
    ...paginationProps,
  },
  reviewers: [],
  revieweesValidationSummary: {},

  // Form related
  isFormLoading: false,
  isFetchingReviewees: false,
  isFetchingEmployees: true,
};

const createReviewCycle = (state = initialState, action) => {
  switch (action.type) {
    case "TOGGLE_IS_LOADING": {
      return {
        ...state,
        isLoading: !state.isLoading,
      };
    }
    case "TOGGLE_IS_FETCHING_REVIEW_CYCLE_DETAILS": {
      return {
        ...state,
        isFetchingReviewCycleDetails: !state.isFetchingReviewCycleDetails,
      };
    }

    case "TOGGLE_IS_CREATING_FORM": {
      return {
        ...state,
        isCreatingForm: !state.isCreatingForm,
      };
    }
    case "TOGGLE_IS_ADDING_REVIEWEE": {
      return {
        ...state,
        isAddingReviewee: !state.isAddingReviewee,
      };
    }
    case "TOGGLE_IS_ADDING_MULTIPLE_REVIEWEES": {
      return {
        ...state,
        isAddingMultipleReviewees: !state.isAddingMultipleReviewees,
      };
    }
    case "TOGGLE_IS_REMOVING_REVIEWEE": {
      return {
        ...state,
        isRemovingAllReviewees: !state.isRemovingAllReviewees,
      };
    }
    case "TOGGLE_IS_REMOVING_SINGLE_REVIEWEE": {
      return {
        ...state,
        isRemovingSingleReviewee: !state.isRemovingSingleReviewee,
      };
    }
    case "SET_REVIEW_CYCLE": {
      const newState = Object.assign({}, state, {
        newlyCreatedReviewCycle: action.payload,
      });
      return newState;
    }
    case "UPDATE_REVIEW_CYCLE": {
      return {
        ...state,
        newlyCreatedReviewCycle: action.payload,
      };
    }
    case "SET_REVIEW_FORMS": {
      return {
        ...state,
        reviewForms: action.payload,
      };
    }
    case "SET_REVIEW_FORM_TEMPLATES": {
      return {
        ...state,
        reviewFormTemplates: action.payload,
      };
    }

    case "SET_CURRENT_FORM_TEMPLATE": {
      return {
        ...state,
        currentFormTemplate: action.payload,
      };
    }

    case "SET_QUESTION_LIBRARY": {
      return {
        ...state,
        questionLibrary: action.payload,
      };
    }
    case "ADD_REVIEW_FORM": {
      return {
        ...state,
        reviewForms: [...state.reviewForms, action.payload],
      };
    }
    case "UPDATE_REVIEW_FORMS": {
      const updatedReviewForms = state.reviewForms.map((form) => {
        return form.id === action.payload.id ? action.payload : form;
      });
      return {
        ...state,
        reviewForms: updatedReviewForms,
      };
    }
    case "SET_EMPLOYEES": {
      return {
        ...state,
        employees: action.payload,
      };
    }
    case "SET_EMPLOYEES_WITH_PAGINATION": {
      return {
        ...state,
        employeesWithPagination: {
          data: action.payload.employees || [],
          pagination: action.payload.pagination || {
            limit: 10,
            ...paginationProps,
          },
        },
      };
    }
    case "RESET_EMPLOYEES_WITH_PAGINATION": {
      return {
        ...state,
        employeesWithPagination: {
          data: [],
          pagination: {
            limit: 10,
            ...paginationProps,
          },
        },
      };
    }
    case "SET_REVIEWEES_WITH_PAGINATION": {
      return {
        ...state,
        revieweesWithPagination: {
          reviewees: action.payload.reviewees || [],
          current_page: action.payload.current_page || 1,
          per_page: action.payload.per_page || 10,
          next_page: action.payload.next_page || null,
          previous_page: action.payload.previous_page || null,
          total_entries: action.payload.total_entries || 0,
        },
      };
    }
    case "RESET_REVIEWEES_WITH_PAGINATION": {
      return {
        ...state,
        revieweesWithPagination: {
          reviewees: [],
          current_page: 1,
          per_page: 10,
          next_page: null,
          previous_page: null,
          total_entries: 0,
        },
      };
    }
    case "SET_REVIEWEES_VALIDATION_SUMMARY": {
      return {
        ...state,
        revieweesValidationSummary: action.payload,
      };
    }
    case "SET_REVIEWEES": {
      return {
        ...state,
        reviewees: action.payload,
      };
    }
    case "UPDATE_REVIEWEES": {
      return {
        ...state,
        reviewees: [...state.reviewees, ...action.payload],
      };
    }
    case "UPDATE_REVIEWEE": {
      return {
        ...state,
        reviewees: state.reviewees?.map((reviewee) => {
          if (reviewee.id === action.payload.id) {
            return action.payload;
          } else {
            return reviewee;
          }
        }),
      };
    }
    case "REMOVE_REVIEWEE": {
      return {
        ...state,
        reviewees: state.reviewees?.filter(
          (reviewee) => Number(reviewee.id) !== Number(action.payload)
        ),
      };
    }
    case "UPDATE_SINGLE_REVIEWEE": {
      return {
        ...state,
        reviewees: state.reviewees?.map((reviewee) => {
          if (reviewee.id === action.payload.id) {
            return action.payload;
          } else {
            return reviewee;
          }
        }),
      };
    }
    case "SET_REVIEWERS": {
      return {
        ...state,
        reviewers: action.payload,
      };
    }
    case "REMOVE_REVIEWER": {
      const { reviewerType, reviewerId } = action.payload;
      return {
        ...state,
        reviewers: {
          ...state.reviewers,
          [reviewerType]: state.reviewers[reviewerType].filter(
            ({ reviewer }) => Number(reviewer.id) !== Number(reviewerId)
          ),
        },
      };
    }
    case "SET_STEPS_STATUS": {
      return {
        ...state,
        stepsStatus: action.payload,
      };
    }
    case "SET_COMPETENCY_ERROR": {
      return {
        ...state,
        competencyError: action.payload,
      };
    }

    case "TOGGLE_IS_FORM_LOADING": {
      return {
        ...state,
        isFormLoading: !state.isFormLoading,
      };
    }

    case "TOGGLE_IS_FETCHING_REVIEWEES": {
      return {
        ...state,
        isFetchingReviewees: true,
      };
    }
    case "TOGGLE_IS_NOT_FETCHING_REVIEWEES": {
      return {
        ...state,
        isFetchingReviewees: false,
      };
    }
    case "TOGGLE_IS_FETCHING_EMPLOYEES": {
      return {
        ...state,
        isFetchingEmployees: true,
      };
    }
    case "TOGGLE_IS_NOT_FETCHING_EMPLOYEES": {
      return {
        ...state,
        isFetchingEmployees: false,
      };
    }
    default:
      return state;
  }
};

export default createReviewCycle;
